import 'normalize.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import 'localization/i18n.ts';
import App from './App';
import React from 'react';
import { render } from 'react-dom';

render(
  <React.Suspense fallback="Loading...">
    <App />
  </React.Suspense>,
  document.querySelector('#root')
);
